'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Range2 = require('./Range');

var _Range3 = _interopRequireDefault(_Range2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Run = function (_Range) {
  (0, _inherits3.default)(Run, _Range);

  function Run(start, end) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, _classCallCheck3.default)(this, Run);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Range.call(this, start, end));

    _this.attributes = attributes;
    return _this;
  }

  Run.prototype.slice = function slice(start, end) {
    return new Run(start + this.start, Math.min(this.end, end + this.start), this.attributes);
  };

  Run.prototype.copy = function copy() {
    return new Run(this.start, this.end, this.attributes);
  };

  return Run;
}(_Range3.default);

exports.default = Run;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-pdf/textkit-core/dist/models/Run.js
// module id = 137
// module chunks = 0